import React from "react";
import FixedSelectInput from "../../input/fixed-select-input";

const Select1Widget = ({ widget, onValueUpdate }) => {
  const handleValueUpdate = (data) => {
    const updatedWidget = { ...widget, value: data };
    onValueUpdate(updatedWidget);
  };

  return (
    <div className="flex items-center h-full w-full">
      {widget && (
        <FixedSelectInput
          valueSpec={widget}
          onChange={handleValueUpdate}
          onError={() => {}}
          multiSelect={false}
          zIndex="var(--z-index-dashboard-input)"
        />
      )}
    </div>
  );
};

export default Select1Widget;
